import { render, staticRenderFns } from "./quizUpload.vue?vue&type=template&id=530bef37&scoped=true&"
import script from "./quizUpload.vue?vue&type=script&lang=js&"
export * from "./quizUpload.vue?vue&type=script&lang=js&"
import style0 from "./quizUpload.vue?vue&type=style&index=0&id=530bef37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530bef37",
  null
  
)

export default component.exports